// extracted by mini-css-extract-plugin
export default {"lineBlock":"Line_lineBlock__nTKku","bigLine":"Line_bigLine__TWZP9","smallLine":"Line_smallLine__PpRuR","heroWord":"Line_heroWord__OR27S","model2":"Line_model2__WNh7J"};